import { ThisConnector } from '../../../api/connector'
import { BaseApiResponse } from '../../../api/fetch/decorate-fetch'

export interface UnmergeModulesArgs {
  organizationID: string
  moduleIds: string[]
}

export async function unmergeModules(
  this: ThisConnector,
  { organizationID, moduleIds }: UnmergeModulesArgs
): Promise<BaseApiResponse[]> {
  return Promise.all(
    moduleIds.map((moduleID) =>
      this.connector.executeDelete<BaseApiResponse>(
        `/${organizationID}/modules/${moduleID}`
      )
    )
  )
}
